import React from "react";
import { CardContent, Typography, Alert } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { IFtp } from "modules/companies/types";

export interface IFtpRow {
  data: IFtp;
  disabled: boolean;
}

const FtpRow: React.FC<IFtpRow> = ({ data, disabled }) => {
  const handleCopyClipboard = async (text: string) => {
    await navigator.clipboard.writeText(text);
  };

  return (
    <>
      <>
        {!disabled ? (
          <Alert severity="error">FTP Desabilitado</Alert>
        ) : (
          <Alert severity="success">FTP Habilitado</Alert>
        )}
      </>
      <CardContent
        sx={{
          border: "1px solid #CCC",
          borderRadius: "5px",
          backgroundColor: "#EEE",
        }}
      >
        <Typography variant="h5" component="div">
          FTP
        </Typography>

        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            <b>HOST:</b>
            <br />
            ftp1.inspecionarcloud.com.br
            <ContentCopy
              sx={{ fontSize: "15px", cursor: "pointer" }}
              onClick={() =>
                handleCopyClipboard("ftp1.inspecionarcloud.com.br")
              }
            />
          </div>
          <div>
            <b>USUÁRIO:</b>
            <br />
            {data.User}{" "}
            <ContentCopy
              sx={{ fontSize: "15px", cursor: "pointer" }}
              onClick={() => handleCopyClipboard(data.User)}
            />
          </div>
          <div>
            <b>SENHA:</b>
            <br />
            **************{" "}
            <ContentCopy
              sx={{ fontSize: "15px", cursor: "pointer" }}
              onClick={() => handleCopyClipboard(data.PasswordString)}
            />
          </div>
        </div>
        {/* <CardActions sx={{ padding: 0, marginTop: "20px" }}>
          <Button variant="contained" size="small">
            Excluir DVR
          </Button>
        </CardActions> */}
      </CardContent>
    </>
  );
};

export { FtpRow };
